var thousandsSeperator = function thousandsSeperator() {
  var number = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '0';
  return number.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};

var formatPrice = function formatPrice(price) {
  var currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '£';
  if (typeof price !== 'number') return price;
  var numRegex = /^([+-]?)((?:\d*\.)?\d+)$/;
  var match = price.toFixed(2).match(numRegex); // replace('-', '−') makes a screen reader understand it's a minus not a dash

  return "".concat(match[1] ? "".concat(match[1].replace('-', '−'), " ") : '').concat(currency).concat(thousandsSeperator(match[2]));
};

export default formatPrice;